<template>
    <div class="ah-page external-invoice-edit-page">
        <ahUploader ref="ahUploader" @change="onChangeAttachment" />
        <div class="page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1 v-if="!form.sno">新增進項發票</h1>
                        <h1 v-else>編輯進項發票</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel" style="margin-top: 25px">
                <div class="panel-header small">
                    <div class="panel-title">發票內容</div>
                </div>
                <div class="panel-body">
                    <div class="receipt-modal-layout">
                        <div v-if="receiptModal.fileExt == 'jpg' || receiptModal.fileExt == 'jpeg' || receiptModal.fileExt == 'png'" class="image-block">
                            <el-image v-if="form.filE_ATT" style="width: 100%" :src="form.filE_ATT" :previewSrcList="[form.filE_ATT]"></el-image>
                            <div style="text-align: center; margin: 12px 0">
                                <el-button size="small" @click="onReplaceAttachment">
                                    更換檔案
                                </el-button>
                            </div>
                        </div>
                        <div class="file-block" v-else-if="receiptModal.fileExt == 'pdf'">
                            <div class="file">
                                <ahFileIcon :ext="receiptModal.fileExt" :url="form.filE_ATT" />
                            </div>
                            <div style="text-align: center; margin: 12px 0">
                                <el-button size="small" @click="onReplaceAttachment">
                                    更換檔案
                                </el-button>
                            </div>
                        </div>
                        <div class="file-block" v-else-if="uploaderVisible">
                            <ahQrCodeUploader :visible="!receiptModal.fileExt" @change="onQrCodeAttChange" />
                            <br />
                            <br />
                            <div class="file">
                                <ahFileIcon />
                            </div>
                            <div style="text-align: center; margin: 12px 0">
                                <el-button size="small" @click="onUploadFile">
                                    上傳檔案 (圖片、PDF檔)
                                </el-button>
                                <div style="font-size: 12px; color: #aaa; margin-top: 3px">(檔案大小上限：25MB)</div>
                            </div>
                        </div>
                        <div class="form-block">
                            <el-form ref="form" :model="form" :label-position="isMobile() ? 'top' : 'right'" label-width="155px" v-loading="isLoading">
                                <el-form-item prop="description" label="摘要" :rules="formRules.description">
                                    <el-input v-model="form.description" :maxlength="100" :show-word-limit="true" />
                                </el-form-item>
                                <el-form-item prop="filE_TYP" :rules="formRules.filE_TYP">
                                    <template v-slot:label>
                                        發票類型
                                        <ahTip>未填寫將被儲存至草稿</ahTip>
                                    </template>
                                    <el-select v-model="form.filE_TYP" placeholder="請選擇" no-data-text="無數據" @change="onFileTypChange">
                                        <el-option :label="item.value" v-for="item in attachmentTypeOptions" :key="item.key" :value="item.key"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item prop="foO_DAT" :rules="formRules.foO_DAT">
                                    <template v-slot:label>
                                        發票日期
                                        <ahTip>未填寫將被儲存至草稿</ahTip>
                                    </template>
                                    <el-date-picker v-model="form.foO_DAT" type="date" value-format="timestamp" placeholder="選擇日期" @change="onCheckInvoiceDuplicate()"> </el-date-picker>
                                </el-form-item>
                                <el-form-item v-if="form.filE_TYP !== 11" prop="foo" :rules="formRules.foo">
                                    <template v-slot:label>
                                        發票號碼
                                        <ahTip>未填寫將被儲存至草稿</ahTip>
                                    </template>
                                    <ahElInputInvoice v-if="!isLoading" v-model="form.foo" @input="onCheckInvoiceDuplicate()" />
                                </el-form-item>
                                <el-form-item v-else prop="foo" :rules="formRules.foo">
                                    <template v-slot:label>
                                        票根號碼
                                        <ahTip>未填寫將被儲存至草稿</ahTip>
                                    </template>
                                    <el-input v-model="form.foo" :maxlength="20" :show-word-limit="true" />
                                </el-form-item>
                                <el-form-item v-if="isInvoiceInfoFulfill && isPayed('G03') && isAuth('G03')" prop="code" label="格式代號">
                                    <span v-if="form.code"> {{ form.code }}</span>
                                    <i v-else-if="isCheckingInvoice" class="el-icon-loading" />
                                    <span v-else style="color: red;">請檢查發票號碼與單據日期</span>
                                </el-form-item>
                                <el-form-item prop="bsn" label="賣方統編" :rules="formRules.bsn">
                                    <div class="bsn-input-set">
                                        <el-input v-model="form.bsn" :maxlength="8" :show-word-limit="true" @input="onBsnChange"></el-input>
                                        <div class="response">
                                            <div v-if="isFetchingCmpName">
                                                <el-tooltip class="item" effect="light" content="查詢商工登記中..." placement="top">
                                                    <i class="el-icon-loading" />
                                                </el-tooltip>
                                            </div>
                                            <div v-else-if="bsnCheckStatus > 0">
                                                <i class="el-icon-success" style="color: #25c700" />
                                            </div>
                                            <div v-else-if="bsnCheckStatus === 0">
                                                <el-tooltip class="item" effect="light" content="此統編查無公司登記資料，請再次確認" placement="top">
                                                    <i class="el-icon-warning" style="color: #ec9600" />
                                                </el-tooltip>
                                            </div>
                                            <div v-else-if="bsnCheckStatus < 0">
                                                <el-tooltip class="item" effect="light" content="無法連線商工資料開放平臺，請手動輸入賣方公司名" placement="top">
                                                    <i class="el-icon-warning" style="color: #ccc" />
                                                </el-tooltip>
                                            </div>
                                        </div>
                                    </div>
                                </el-form-item>
                                <el-form-item prop="sellerName" label="賣方公司名" :rules="formRules.sellerName">
                                    <el-autocomplete
                                        v-model.trim="form.sellerName"
                                        class="inline-input"
                                        :fetch-suggestions="onSearchCompany"
                                        placeholder="輸入公司名"
                                        :trigger-on-focus="false"
                                        style="width: 100%"
                                        @select="onSelectCompany"
                                        :maxlength="100"
                                        :show-word-limit="true"
                                        :disabled="isFetchingCmpName"
                                    ></el-autocomplete>
                                </el-form-item>
                                <el-form-item prop="amt" :rules="formRules.amt">
                                    <template v-slot:label>
                                        發票總額(含稅)
                                        <ahTip>未填寫將被儲存至草稿</ahTip>
                                    </template>
                                    <money-input v-model="form.amt" style="width: 200px; margin-right: 10px" @change="onAmtChange" />
                                    TWD
                                </el-form-item>
                                <el-form-item prop="tax" label="營業稅" :rules="formRules.tax">
                                    <money-input v-model="form.tax" style="width: 200px" />
                                </el-form-item>
                                <el-form-item label="銷售額(未稅)">
                                    <money-input v-model="nonTaxAmt" disabled style="width: 200px" />
                                </el-form-item>
                                <el-form-item prop="mem" label="備註">
                                    <el-input v-model="form.mem" :maxlength="100" type="textarea" autosize :show-word-limit="true"> </el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div class="button-set">
                        <el-button v-if="form.sno && !isQR()" type="danger" @click="onDelete" :loading="isDeleting">
                            刪除
                        </el-button>
                        <el-button @click="onCancel">取消</el-button>
                        <el-button v-if="!isQR()" type="primary" @click="onSubmit">
                            儲存
                            <span v-if="isDraft">(草稿)</span>
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { isGuiNumberValid } from 'taiwan-id-validator';
import { attachmentTypes } from '@/assets/commonData/options';
import ahFileIcon from '@/components/ui/ahFileIcon.vue';
import ahElInputInvoice from '@/components/ui/ahElInputInvoice.vue';
import ahUploader from '@/components/ui/Uploader/ahUploader.vue';
import ahQrCodeUploader from '@/components/ui/ahQrCodeUploader.vue';
import invoiceSerialNumber from '@/assets/commonData/invoiceSerialNumber';

export default {
    components: {
        ahFileIcon,
        ahElInputInvoice,
        ahUploader,
        ahQrCodeUploader,
    },
    data() {
        return {
            isLoading: false,
            isDeleting: false,
            uploaderVisible: false,
            isCheckingInvoice: false,
            isFetchingCmpName: false,
            bsnCheckStatus: null,

            receiptModal: {
                visible: false,
                dataSource: null,
                fileExt: null,
            },
            form: {
                sno: null,
                filE_ATT: null, // 檔案
                filE_TYP: null, // 檢附發票類型
                description: null, // 摘要
                foO_DAT: null, // 發票日期
                foo: null, // 發票號碼
                sellerName: null, // 公司名稱 （sellerName）
                bsn: null, // 統一編號
                amt: 0, // 發票總額(含稅)
                amT_UnTax: 0, // 發票未稅金額
                tax: 0, // 發票營業稅
                mem: null, // 備註
                code: null,
            },
        };
    },
    computed: {
        attachmentTypeOptions() {
            return attachmentTypes.filter((o) => [1, 2, 3, 10, 11].includes(o.key));
        },
        nonTaxAmt() {
            return this.form.amt - this.form.tax;
        },

        formRules() {
            const validateBsn = (rule, value, callback) => {
                if (value && !isGuiNumberValid(value, true)) {
                    callback(new Error('統一編號格式不正確'));
                } else {
                    callback();
                }
            };
            const invoiceValidate = (rule, value, callback) => {
                if (value?.length < 10) callback(new Error('請輸入完整發票'));
                callback();
            };
            return {
                bsn: [{ validator: validateBsn, trigger: 'blur' }],
                foo: [{ validator: this.form.foo && this.form.filE_TYP !== 11 ? invoiceValidate : [], trigger: 'blur' }],
            };
        },
        isDraft() {
            return !this.form.filE_TYP || !this.form.foO_DAT || !this.form.foo || !this.form.amt;
        },
        isInvoiceInfoFulfill() {
            return (this.form.filE_TYP !== 11 && this.form.foo?.length === 10 && this.form.foO_DAT) || this.form.filE_TYP === 11;
        },
    },
    mounted() {
        if (this.$route.params.sno) this.init();
        else this.uploaderVisible = true;
    },
    methods: {
        async init() {
            try {
                this.isLoading = true;
                const resp = await this.$api({
                    url: '/PaymentInvoice/GetPaymentInvoiceInfo',
                    method: 'GET',
                    params: { sno: this.$route.params.sno },
                });

                console.log('Tax Credit Invoice Detail:', resp.data.item);
                this.form = { ...resp.data.item };
                this.receiptModal.fileExt = _.last(this.form.filE_ATT?.split('.'));
                this.uploaderVisible = true;
            } finally {
                this.isLoading = false;
            }
        },
        onFileTypChange() {
            if (this.form.filE_TYP === 11) this.form.code = 22;
            else this.onCheckInvoiceDuplicate();
        },
        onReplaceAttachment() {
            this.receiptModal.fileExt = null;
        },
        onUploadFile() {
            this.$refs.ahUploader.onUploadFile();
        },
        async onSearchCompany(queryString, callback) {
            if (queryString === ' ') {
                callback([]);
                return;
            }
            const resp = await this.$api({
                url: '/PaymentManagenmentPage/QueryReciptFile',
                params: { keyword: queryString },
                method: 'GET',
            });

            if (resp.data.items.length > 0 || resp.data.paymentInvoiceItems.length > 0) {
                const list = [];
                const FULL_LIST = [...resp.data.items, ...resp.data.paymentInvoiceItems];

                FULL_LIST.forEach((receipt) => {
                    const searchKey = receipt.companyName ? 'companyName' : 'sellerName';
                    const FOUND = list.find((x) => x.value === receipt[searchKey]);

                    // 如果該公司名還沒有存在清單中
                    if (!FOUND) {
                        // 建立清單物件
                        list.push({
                            value: receipt[searchKey],
                            bsn: receipt.bsn,
                        });
                    }
                });
                callback(list);
            } else {
                callback([]);
            }
        },
        onSelectCompany(item) {
            this.form.bsn = item.bsn;
        },
        onAmtChange() {
            const rat = 1.05;
            this.form.tax = Math.round(this.form.amt - Math.round(this.form.amt / rat));
        },
        onChangeAttachment(receiptData) {
            // apply data
            if (receiptData) {
                _.forEach(receiptData, (value, key) => {
                    if (value) this.form[key] = value;
                });
                this.onBsnChange();
                this.onCheckInvoiceDuplicate();

                // fileType
                if (receiptData.filE_ATT && receiptData.filE_ATT?.trim() !== '') {
                    this.receiptModal.fileExt = receiptData.filE_ATT
                        .split('.')
                        .pop()
                        .toLowerCase();
                    console.log('fileExt', this.receiptModal.fileExt);
                } else {
                    this.receiptModal.fileExt = null;
                }
            }
        },

        async onDelete() {
            this.isDeleting = true;
            try {
                await this.$api({
                    url: '/PaymentInvoice/DeletePaymentInvoice',
                    method: 'DELETE',
                    data: { sno: this.form.sno },
                });
                this.onCancel();
            } finally {
                this.isDeleting = false;
            }
        },
        onCancel() {
            if (Number(this.$route.query.fromYear) > 0 && Number(this.$route.query.fromPhase) > 0) {
                this.$router.push({ name: 'tax-credit-invoice', query: { year: this.$route.query.fromYear, phase: this.$route.query.fromPhase } });
            } else {
                this.$router.push({ name: 'tax-credit-invoice' });
            }
        },
        onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    console.log(this.form);
                    if (!this.form.filE_ATT) {
                        this.$message({
                            showClose: true,
                            message: '請至少上傳圖片或文件',
                            type: 'error',
                        });
                        return false;
                    }
                    const resp = await this.$api({
                        url: '/PaymentInvoice/UpsertPaymentInvoice',
                        method: 'POST',
                        data: { ...this.form, amT_UnTax: this.nonTaxAmt },
                    });
                    console.log(resp);

                    if (this.isDraft) {
                        this.$message({
                            showClose: true,
                            message: '已儲存至「草稿」',
                            type: 'success',
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            message: '已成功建立',
                            type: 'success',
                        });
                    }

                    this.$router.push({
                        name: 'tax-credit-invoice',
                        query: {
                            year: moment(this.form.foO_DAT).year(),
                            phase: Math.ceil((moment(this.form.foO_DAT).month() + 1) / 2),
                        },
                    });
                    return true;
                }
                return false;
            });
        },
        onQrCodeAttChange(url, meta) {
            this.receiptModal.fileExt = url
                .split('.')
                .pop()
                .toLowerCase();
            this.form.filE_ATT = url;

            if (meta.foo) this.form.foo = meta.foo;
            if (meta.foO_DAT) this.form.foO_DAT = meta.foO_DAT;
            if (meta.filE_TYP) this.form.filE_TYP = meta.filE_TYP;
            if (meta.tax) this.form.tax = meta.tax;
            if (meta.amt) this.form.amt = meta.amt;
            if (meta.bsn) {
                this.form.bsn = meta.bsn;
                this.onBsnChange();
            }
            if (meta.foo && meta.foO_DAT) this.onCheckInvoiceDuplicate();
        },

        async onCheckInvoiceDuplicate(skipCheckCode) {
            if (this.isInvoiceInfoFulfill && !this.isCheckingInvoice) {
                try {
                    this.isCheckingInvoice = true;
                    // 自動格式代號
                    if (!skipCheckCode) this.form.code = this.getPaymentValidateCode(this.form);
                } finally {
                    this.isCheckingInvoice = false;
                }
            }
        },
        getPaymentValidateCode(item) {
            // if (item.typ < 0) return undefined;
            if (item.filE_TYP === 11) return 22;

            const isIncome = false;
            const fooMonth = moment(item.foO_DAT).month() + 1;
            const fooYear = moment(item.foO_DAT).year();
            const fooKey = `${item.foo[0]}${item.foo[1]}`;
            const TYPE = _.chain(invoiceSerialNumber)
                .filter(['year', fooYear])
                .find((o) => o.month.includes(fooMonth))
                .get('datas')
                .find((o) => o.serialNumbers.includes(fooKey))
                .get('name')
                .value();

            const isCashierTripleInvoice = item.filE_TYP === 10;
            const TYPE_CODE = { A: 1, B: 2, D: 5 };
            if (TYPE) return Number(`${isIncome ? 3 : 2}${isCashierTripleInvoice ? 5 : TYPE_CODE[TYPE]}`);

            return null;
        },
        async onBsnChange() {
            const { bsn } = this.form;
            if (bsn.length === 8) {
                this.isFetchingCmpName = true;
                try {
                    const resp = await this.$api({
                        url: '/PaymentManagenmentPage/GetCompanyName',
                        params: { bsn },
                        method: 'GET',
                    });
                    this.form.sellerName = resp.data.companyName;
                    this.bsnCheckStatus = resp.data.status;
                } catch (error) {
                    console.log(error);
                } finally {
                    this.isFetchingCmpName = false;
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.external-invoice-edit-page .button-set {
    display: flex;
    justify-content: center;
    margin-top: 40px;
}
</style>

<style lang="scss">
.external-invoice-edit-page .receipt-modal-layout {
    display: block;
    width: 100%;

    @media (min-width: 992px) {
        display: table;
    }

    .file-block {
        display: block;
        height: 100%;
        background-color: #f6f6f6;
        padding: 25px;

        @media (min-width: 992px) {
            display: table-cell;
            vertical-align: top;
            height: 100%;
            position: relative;
            vertical-align: middle;
        }
    }

    .image-block {
        display: block;
        background-color: #f6f6f6;
        padding: 25px;

        @media (min-width: 992px) {
            display: table-cell;
            vertical-align: top;
            height: 100%;
            position: relative;
            vertical-align: middle;
        }

        .el-image {
            img {
                object-fit: contain;
                max-height: 500px;
            }
        }
    }

    .form-block {
        display: block;
        padding: 25px;
        width: 650px;

        @media (max-width: 720px) {
            width: 100%;
        }

        @media (min-width: 992px) {
            display: table-cell;
            vertical-align: top;
        }
    }
    .bsn-input-set {
        display: grid;
        grid-template-columns: auto 50px;
        gap: 10px;
    }
}
</style>
